'use strict';

angular.module('docketbook').
  service('billingService', function (Restangular, accessControl) {
    let billingDetails = { loading: true };
    let plans = [];

    this.getBillingDetails = function (successCb) {
      let currentOrg = accessControl.currentOrg();

      if (!currentOrg) {
        return;
      }

      this.getOrganisationBilling(currentOrg.id, function (rsp) {
        billingDetails = rsp;
        billingDetails.loading = true;
        if (billingDetails.currentPlanId) {
          for (let i = 0; i < plans.length; i++) {
            if (plans[i].id == billingDetails.currentPlanId) {
              billingDetails.currentPlan = plans[i];
            }
          }
        }

        if (billingDetails.sources && billingDetails.sources.length > 0) {
          billingDetails.currentCard = billingDetails.sources[0];
        }

        billingDetails.loading = false;

        if (successCb) {
          successCb(billingDetails);
        }
      }, function (err) {
        billingDetails.loading = false;
      });
    };

    /******* Get Org Billing ********/
    this.getOrganisationBilling = function (orgId, successCb, failureCb) {
      var baseBilling = Restangular.all('organisations').one(orgId).all('billing');
      baseBilling.customGET().then(successCb, failureCb);
    };

    /******* Update Org Billing *******/
    this.updateOrganisationBilling = function (orgId, billingDetails, successCb, failureCb) {
      const baseBilling = Restangular.all('organisations').one(orgId).all('billing');
      const reqObj = {plan: billingDetails.plan, token: billingDetails.token};

      if (billingDetails.features_trial) {
        reqObj.features_trial = billingDetails.features_trial
      }
      baseBilling.customPUT(reqObj).then(successCb, failureCb);
    };

    /******** Update Org Billing Contact *********/
    this.updateOrganisationBillingContact = function (orgId, contactDetails, successCb, failureCb) {
      const baseBilling = Restangular.all('organisations').one(orgId).all('billing/contact');
      const fields = ['firstName', 'lastName', 'emailAddress', 'address', 'name', 'phoneNumber'];
      let postObj = {};

      fields.forEach(function (field) {
        if (contactDetails[field] != null) {
          postObj[field] = contactDetails[field];
        }
      });

      baseBilling.customPUT(postObj).then(successCb, failureCb);
    };

    /******* Search ABN *******/
    this.searchAbn = function (abn, successCb, failureCb) {
      Restangular.all('abn').one(abn).customGET().then(successCb, failureCb);
    };

    /******* Get plans for billing ********/
    const sortBy = (key) => {
      return (a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0);
    };

    this.getPlans = function (successCb, failureCb) {
      if (plans.length > 0) {
        return successCb(plans);
      }

      Restangular.all('plans').getList().then((rsp) => {
        plans = rsp.concat().sort(sortBy('pricePerInterval'));

        successCb(plans);
      }, failureCb);
    };

    this.getBillingDetails();
  });



// WEBPACK FOOTER //
// ./src/services/billingService.js